import styled, { css } from 'styled-components'

import { maxmedia, minmedia } from '../../styles/media-queries'
import { lightergray, body } from '../../styles/colors'

export const Wrap = styled.div`
  width: 100%;
  background: ${lightergray};

  ${minmedia.large`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  `}
`

export const Filler = styled.div`
  padding-left: 4%; // match logo
  width: 215px; // match logo
  background: ${body};

  ${maxmedia.xmlarge`
    display: none;
  `}
  ${minmedia.xxlarge`
    width: 250px;
  `}
`

export const BreadContainer = styled.div`
  width: 450px;
  text-align: right;
  padding-right: 2rem;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;

  ${maxmedia.xmlarge`
    display: none;
  `}

  & > div {
    margin: 0;
    max-width: 100%; //reset
    width: auto; //reset
  }
`

export const Tabs = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding-top: .5rem;

  ${minmedia.xmlarge`
    padding-top: .75rem;
    padding-left: 100px; //center properly
    width: auto;
    flex: 1;
  `}
  ${minmedia.xxlarge`
    padding-left: 200px; //center properly
  `}
`

export const Tab = styled.div`
  transition: background-color .5s;
  width: 47%;
  text-align: center;
  padding: .75rem 0
  background-color: ${lightergray};
  border-top-left-radius: .25rem;
  border-top-right-radius: .25rem;
  margin: 0 1%;
  cursor: pointer;
  font-size: 18px;

  &:hover {
    background-color: ${body};
  }

  span:first-child {
    display: none;
  }

  ${minmedia.medium`
    width: auto; //reset
    min-width: 180px;
    margin: 0 .2rem;
    padding: 1rem;
    font-size: 18px;
  `}
  ${minmedia.large`
    padding: 1.5rem;

    span:first-child {
      display: block;
    }
    span:last-child {
      display: none;
    }
  `}

  ${props => props.active && css`
    background-color: ${body};
    font-weight: 400;
  `}
`



// WEBPACK FOOTER //
// ./src/components/TabBreadcrumb/styles.js